import { gql } from 'graphql-request';

export const FETCH_SUBSCRIPTION_BANNER_QUERY = gql`
  query ($id: ID!, $filter: CollectionFilter) {
    collection(id: $id, filter: $filter) {
      id
      rails {
        contents {
          ... on Movie {
            assetType
            id
            title
            image {
              portrait
            }
          }
        }
      }
    }
  }
`;
